@if (opportunityListingForm) {
<div class="main-container">
  <div class="header-container">
    <div
      class="header-section"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <h3>{{mode}} Opportunity Listing</h3>
      <div class="button-container">
        <button
          mat-button
          [disabled]="!opportunityListingForm.valid"
          (click)="saveListing()"
          class="save-button primary-button small-button"
          type="submit"
        >
          <mat-icon>check</mat-icon> Save
        </button>
        <button
          type="button"
          mat-button
          class="small-button"
          (click)="closeListing()"
        >
          <mat-icon>close</mat-icon> Cancel
        </button>
        @if (mode=='Edit') {
        <button
          type="button"
          mat-button
          class="small-button"
          (click)="deleteListing()"
        >
          <mat-icon>delete</mat-icon> Delete
        </button>
        }
      </div>
    </div>
  </div>
  <div class="content-container">
    <ng-scrollbar>
      <form [formGroup]="opportunityListingForm">
        <section>
          <h4>Opportunity Details</h4>
          <div class="section-content">
            <div>
              <div class="detail-label">Position</div>
              <div>{{position.title}}</div>
            </div>
            <div>
              <div class="detail-label">Opportunity Description</div>
              <div class="description mb-1">
                <em>This will display publicly on opportunity boards.</em>
              </div>
              <rich-text-editor
                [form]="opportunityListingForm"
                [attributes]="attributes"
                [includeTeamData]="true"
                field="description"
                placeholder="Add description"
              ></rich-text-editor>
            </div>
            <div>
              <div class="detail-label">Opportunity Dates</div>
              <div
                class="container"
                fxLayoutAlign="space-between"
                fxLayout="row"
              >
                <mat-form-field appearance="outline" floatLabel="always">
                  <mat-label>Opportunity Start Date</mat-label>
                  <mat-select
                    style="font-size: 13px"
                    (selectionChange)="onSelectedStartDateChange()"
                    [(value)]="selectedStartDate"
                  >
                    <mat-option value="Same as team start date">
                      Same as team start date
                    </mat-option>
                    <mat-option value="Specific date">
                      Specific date
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field
                  appearance="outline"
                  floatLabel="always"
                  fxFlex="40%"
                >
                  <input
                    style="font-size: 13px"
                    matInput
                    [matDatepicker]="startPicker"
                    formControlName="startDate"
                    [required]="false"
                    placeholder="{{ getStartDatePlaceholder() }}"
                    (dateChange)="startDateChange()"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="startPicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                  @if
                  (opportunityListingForm.controls.startDate.hasError('startDateBeforeTeamStartDate'))
                  {
                  <mat-error>
                    Start date cannot be before the team's start date</mat-error
                  >
                  } @if
                  (opportunityListingForm.controls.startDate.hasError('required')
                  ) {
                  <mat-error> Start date is required</mat-error>
                  } @if
                  (opportunityListingForm.controls.startDate.hasError('startDateCannotBeAfterTeamEndDate'))
                  {
                  <mat-error>
                    Start date cannot be after the team's end date</mat-error
                  >
                  } @if
                  (opportunityListingForm.controls.startDate.hasError('startDateBeforeEndDate'))
                  {
                  <mat-error>
                    Start date cannot be after the end date</mat-error
                  >
                  }
                </mat-form-field>
              </div>
              <div
                class="container"
                fxLayoutAlign="space-between"
                fxLayout="row"
              >
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Opportunity End Date</mat-label>
                  <mat-select
                    style="font-size: 13px"
                    (selectionChange)="onSelectedEndDateChange()"
                    [(value)]="selectedEndDate"
                  >
                    <mat-option value="Same as team end date">
                      Same as team end date
                    </mat-option>
                    <mat-option value="Specific date">
                      Specific date
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field
                  appearance="outline"
                  floatLabel="always"
                  fxFlex="40%"
                >
                  <input
                    style="font-size: 13px"
                    matInput
                    [matDatepicker]="endPicker"
                    formControlName="endDate"
                    [required]="false"
                    placeholder="{{ getEndDatePlaceholder() }}"
                    (dateChange)="endDateChange()"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="endPicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #endPicker></mat-datepicker>
                  @if
                  (opportunityListingForm.controls.endDate.hasError('endDateCannotBeBeforeTeamStartDate'))
                  {
                  <mat-error>
                    End date cannot be before the team's start date</mat-error
                  >
                  } @if
                  (opportunityListingForm.controls.endDate.hasError('required')
                  ) {
                  <mat-error> End date is required</mat-error>
                  } @if
                  (opportunityListingForm.controls.endDate.hasError('endDateCannotBeAfterTeamEndDate'))
                  {
                  <mat-error>
                    End date cannot be after the team's end date</mat-error
                  >
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        </section>
        <section>
          <h4>Listing Details</h4>
          <div class="section-content">
            <div>
              <div class="detail-label">Add to opportunities board(s)</div>
              <multiselect
                [compactSize]="true"
                [items]="boards"
                [filterMode]="false"
                [selectedItems]="selectedBoards"
                (selectionChanged)="multiSelectChanged($event)"
                [placeholder]="'Please select...'"
              ></multiselect>
            </div>
            <div>
              <div class="detail-label">List until:</div>
              <mat-radio-group
                class="opportunity-deadline"
                formControlName="hasDeadline"
                (change)="hasDeadlineChanged()"
              >
                <mat-radio-button color="primary" [value]="false">
                  Ongoing</mat-radio-button
                >
                <mat-radio-button
                  color="primary"
                  [value]="true"
                  class="deadline-option"
                  >Close on:
                </mat-radio-button>
              </mat-radio-group>
              @if (opportunityListingForm.value.hasDeadline) {
              <div class="deadline-picker">
                <mat-form-field appearance="outline" floatLabel="always">
                  <input
                    type="text"
                    matInput
                    [matDatepicker]="deadlinePicker"
                    formControlName="deadline"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="deadlinePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #deadlinePicker></mat-datepicker>
                </mat-form-field>
                @if
                (opportunityListingForm.controls.deadline.hasError('matDatepickerParse'))
                {
                <mat-error> Deadline must be a valid date </mat-error>
                } @if (
                (opportunityListingForm.controls.deadline.hasError('required')
                ||
                opportunityListingForm.controls.deadline.hasError('notEmpty')) )
                {
                <mat-error> Deadline is required </mat-error>
                }
              </div>
              }
            </div>
            <div>
              <div class="detail-label">Form</div>
              <div class="description">
                <em
                  >Collect additional information from those who express
                  interest in this opportunity.</em
                >
              </div>
              <app-form-picker
                [form]="opportunityListingForm"
                controlName="selectedForm"
                [applications]="teamForms"
                placeholder="Select form"
                [required]="true"
              ></app-form-picker>
              @if (opportunityListingForm.controls.selectedForm.value) {
              <button
                mat-button
                class="preview-application"
                (click)="previewForm()"
              >
                Preview Form
              </button>
              }
            </div>
            <div class="container" fxLayoutAlign="space-between" fxLayout="row">
              <div class="detail-label">
                Auto-add to {{ 'team' | platformLabel }}
              </div>
              <mat-slide-toggle
                color="primary"
                name="autoAdd"
                formControlName="autoAdd"
              ></mat-slide-toggle>
            </div>
            @if (opportunityListingForm.value.autoAdd) {
            <div class="container" fxLayoutAlign="space-between" fxLayout="row">
              <div class="detail-label status-align">Add as:</div>
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-select [(value)]="selectedStatus">
                  <mat-option value="Accepted"> Accepted </mat-option>
                  <mat-option value="Picked"> Picked </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            }
          </div>
        </section>
      </form>
    </ng-scrollbar>
  </div>
</div>
}
